import { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Providers } from "./Providers";
import { routes } from "./routes";
import ProtectedRoutes from "./components/navigation/ProtectedRoutes";
import { AuthGate } from "./pages/login/AuthGate";
import { Spinner } from "./components/Spinner";
import { clearCognitoCookies } from "./lib/navigation";
import { setEnv } from "@workspace/shared";
import { CheckForUpdatesDialog, SupportCenter, UpdateAvailableModal } from "@workspace/ui";
import { initializeAmplify } from "@dashboard/amplify-setup.ts";

setEnv({
  API_URL: import.meta.env.VITE_API_BASE_URL,
  API_KEY: import.meta.env.VITE_API_KEY,
});

initializeAmplify();
export function App() {
  useEffect(() => {
    // Clear legacy Cognito cookies to ensure clean authentication state
    clearCognitoCookies();
  }, []);

  return (
    <BrowserRouter
      basename="/"
      future={{ v7_startTransition: true }}
    >
      <Suspense fallback={<Spinner />}>
        <Providers>
          <AuthGate>
            <ProtectedRoutes routes={routes} />
          </AuthGate>
          {/* Once, for the dashboard and every practice app: "Update
              Available!" when a new version is waiting, and the drawer's
              Check For Updates confirmation (in-game parity, 2026-10-07). */}
          <UpdateAvailableModal />
          <CheckForUpdatesDialog />
          {/* Help and Support — the practice FAQ, Contact Us and the support
              chat, opened from every app's drawer (2026-10-08). */}
          <SupportCenter />
        </Providers>
      </Suspense>
    </BrowserRouter>
  );
}
